import { useQueries, useQuery } from "@tanstack/react-query";
import { GET_MESSAGES } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { useCurrentUser } from "./useCurrentUser";

const fetchMessagesForSubscription = async ({ queryKey }) => {
  const [, { subscriptionID }] = queryKey;
  const { getMessages } = await graphQLClient.request(GET_MESSAGES, {
    subscriptionID,
  });

  return getMessages;
};

export const useGetMessagesForUserId = () => {
  const currentUser = useCurrentUser();

  return useQuery({
    queryKey: ["messages", currentUser.userID],
    queryFn: () =>
      fetchMessagesForSubscription({
        queryKey: ["messages", { subscriptionID: currentUser?.userID }],
      }),
    enabled: !!currentUser.userID,
  });
};

export const useGetMessagesForSections = (
  sections,
  userType,
  enabled = true,
) => {
  const messageQueries = useQueries({
    queries: (sections ?? []).map((section) => {
      const subscriptionID =
        userType === "climber"
          ? section.climberSubscription
          : section.coachSubscription;

      return {
        queryKey: ["messages", { subscriptionID }],
        queryFn: fetchMessagesForSubscription,
        enabled: enabled && !!subscriptionID && sections.length > 0,
      };
    }),
  });

  const refetch = () => {
    messageQueries.forEach((query) => {
      query.refetch();
    });
  };

  const isLoading = messageQueries.some((query) => query.isLoading);
  const isError = messageQueries.some((query) => query.isError);
  const errors = messageQueries
    .filter((query) => query.isError)
    .map((query) => query.error?.message);

  const messages = messageQueries
    .map((query) => query.data)
    .filter(Boolean)
    .flat()
    .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp));

  return { messages, isLoading, isError, errors, refetch };
};
